import React from 'react';
import WorkiDtlLogo from "../../../images/background/workiDtl.png"

const WorkiStatic = (props) => {
    return (
        <div>
            <div style={{ marginTop: 8 }}>
                <img src={WorkiDtlLogo} alt='' style={{ width: '100%', borderRadius: 4 }} />
            </div>
            <div style={{ marginTop: 8, fontSize: 14, fontWeight: 400, marginBottom: 16 }}>
                <p>Холбогчийг ашигласнаар сонгон шалгаруулалтад тэнцсэн ажилтны мэдээллүүдийг  worki системээс татаж, идэвхтэй ажилтны жагсаалт руу хялбараар нэмэх боломжтой болно.</p>
            </div>
        </div>
    );
}

export default WorkiStatic;